import {
  REQUEST_CAMPAIGN_LIST,
  REQUEST_CAMPAIGN
} from './mutation-types'

import axiosInst from '@/utility/axiosInst'

export default {
  requestCampaignList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/campaign/list", {
      params: {
          page: currentPage,
          searchType: searchType,
          searchWord : searchWord
        }
      }).then((res) => {
        commit(REQUEST_CAMPAIGN_LIST, res.data)
      })
  },
  requestCampaign({commit}, campaignSeq) {
    return axiosInst.springAxiosInst.get(`/admin/campaign/campaign/${campaignSeq}`)
      .then((res) => {
        commit(REQUEST_CAMPAIGN, res.data)
      })
  },
  requestSaveCampaign({}, payload) {
    return axiosInst.springAxiosInst.post("/admin/campaign/save-campaign", payload)
      .then((res) => {
        return res.data
      })
  },
  requestDeleteCampaigns({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/campaign/delete-campaigns', payload)
    .then((res) => {
      return res.data
    })
  }
}